module.exports = __webpack_public_path__ + "images/feature/office-preview-1c451ea24a9f5007a546ca570abc1383.png";